<template>
  <a
    :href="hit.url"
    class="flex flex-col bg-blue-50 hover:bg-blue-200 p-2 lg:col-span-3 self-start"
    :aria-label="hit.title"
  >
    <h3 class="text-xl link link--primary">
      {{ hit.title }}
    </h3>   
    <div class="prose prose-sm">
      {{ hit.displayHitType }}
    </div> 
  </a>
</template>

<script lang="ts">
export default { name: 'CategoryHit' }
</script>

<script setup lang="ts">
import { Hit } from '~/types/Hit'

defineProps<{ hit: Hit }>()
</script>
